import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/onSite/lfpGame/infoWidget';
import {
    REQUEST_FETCH_LFP_GAME,
    SUCCESS_FETCH_LFP_GAME,
    FAIL_FETCH_LFP_GAME,
    REQUEST_FETCH_LFP_GAME_WINNER,
    SUCCESS_FETCH_LFP_GAME_WINNER,
    FAIL_FETCH_LFP_GAME_WINNER
} from '../../../../actions/entities/lfpGame';

const initialLfpGameInfoWidgetState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        id: type === FAIL_FETCH_LFP_GAME ? null : state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialLfpGameInfoWidgetState, {
    [REQUEST_FETCH_LFP_GAME]: request,
    [SUCCESS_FETCH_LFP_GAME]: success,
    [FAIL_FETCH_LFP_GAME]: fail,

    [REQUEST_FETCH_LFP_GAME_WINNER]: request,
    [SUCCESS_FETCH_LFP_GAME_WINNER]: success,
    [FAIL_FETCH_LFP_GAME_WINNER]: fail
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/lfpGame/infoWidget.js